import React from 'react';
import {Helmet} from "react-helmet";
import Layout from '../../components/Layout';
import AudiForm from '../../components/AudiForm';
import ReturnToButton from '../../components/ReturnToButton';
import AFSDisclaimer from './AFSDisclaimer';
import MaintenanceMessage from '../../components/MaintenanceMessage';
import queryString from 'query-string';
import { gtmPageview } from '../../functions/gtm';
import {
    PATH_AFS_FLEET_ENQUIRY,
    PATH_THANKS,
    FIELD_TEXT,
    FIELD_TEXTAREA,
    FIELD_CHECKBOX,
    MAINTENANCE_SF,
    DEFAULT_THEME
} from '../../constants';

const fields = [
    {
        field: FIELD_TEXT,
        name: "firstName",
        label: "First name"
    },
    {
        field: FIELD_TEXT,
        name: "lastName",
        label: "Last name"
    },
    {
        field: FIELD_TEXT,
        name: 'role',
        label: 'Your role'
    },
    {
        field: FIELD_TEXT,
        name: 'businessName',
        label: 'Business name'
    },
    {
        field: FIELD_TEXT,
        name: "emailAddress",
        label: "Email"
    },
    {
        field: FIELD_TEXT,
        name: "phoneNumber",
        label: "Phone number"
    },
    {
        field: FIELD_TEXT,
        name: "postcode",
        label: "Postcode"
    },
    {
        field: FIELD_TEXTAREA,
        name: 'message',
        label: 'Message'
    },
    [
        {
            field: FIELD_CHECKBOX,
            name: "optIn",
            label: "I would like to hear more about Audi Financial Services Offers.",
            colClass: "col-12"
        },
        {
            field: FIELD_CHECKBOX,
            name: "termsAndConditions",
            label:"Consent of Terms & Conditions and Privacy Policy.",
            colClass: "col-12"
        }
    ]
];

const validationSchema = {
    termsAndConditions: {
        truthy: {message: "You must agree to the Terms and Conditions and Privacy Policy"}
    },
    message: {
        presence: {message: "This field is required", allowEmpty: false}
    },
    businessName: {
        presence: {message: "Please enter your business name", allowEmpty: false}
    }
};

class AFSFleetEnquiry extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            submitted: false,
            submittedData: {}
        }
    }

    componentDidMount() {
        gtmPageview(PATH_AFS_FLEET_ENQUIRY);
    }

    onSubmit = (values) => {
        this.setState({submitted: true, submittedData: values});
        this.props.history.push(`${PATH_AFS_FLEET_ENQUIRY}${PATH_THANKS}${this.props.location.search}`);
        gtmPageview(`${PATH_AFS_FLEET_ENQUIRY}${PATH_THANKS}`);
    }

    render() {
        const query = queryString.parse(this.props.location.search);
        const theme = query.theme || DEFAULT_THEME;
        const {submitted, submittedData} = this.state;
        return (
            <Layout ui={query.ui} embedded={query.embedded} wide={query.wide} theme={theme}>
                <Helmet>
                    <title>Fleet Enquiry | Audi Financial Services</title>
                </Helmet>

                <main className="audi-forms__page">

                    {submitted && <div className="pt-3 pt-medium-5">
                        <h1 className="aui-headline-3 mb-4">Thank you for your enquiry.</h1>
                        <p className="mb-3">Your enquiry has been submitted and you will receive an email confirmation shortly.</p>
                        <ReturnToButton query={query} theme={theme} />
                    </div>}

                    {!submitted && <div className="pt-3 pt-medium-5">
                        {MAINTENANCE_SF && <MaintenanceMessage opts={[
                            <>Call us on <a className="aui-textlink" href="tel:1300734567">1300 734 567</a>, between 9am – 5pm (AEST), Monday – Friday.</>
                        ]} />}
                        <AudiForm formName="afs-fleet-enquiry"
                            fields={fields}
                            hiddenFields={{enquiryType: "fleet"}}
                            schema={validationSchema}
                            onSubmitSuccess={this.onSubmit}
                            submitIsStretched={false}
                            theme={theme}
                        />
                        <AFSDisclaimer />
                    </div>}

                </main>
            </Layout>
        );
    }
}

export default AFSFleetEnquiry;
